import React from 'react'
import { connect } from 'react-redux'
import { xgroupScheme } from '../../data/schema/struct-schema'
import Dialog from '../../component/dialog'
import Form, { Field } from '../../component/form/form'
import ButtonList from '../../component/form/buttonlist'

function Xgroup({ disabledIds, values, formState, type, ...props }) {
  return (
    <Dialog
      title="X-Group"
      className="xgroup"
      params={props}
      hasSelectValues={values}
      result={() => formState.result}>
      <Form schema={xgroupScheme} init={{ values }} {...formState}>
        <Field
          name="values"
          multiple={type === 'atom'}
          labelPos={false}
          component={ButtonList}
          disabledIds={disabledIds}
        />
      </Form>
    </Dialog>
  )
}

export default connect(store => ({ formState: store.modal.form }))(Xgroup)
